<template>
  <v-list style="background-color: rgba(0, 0, 0, 0)">
    <v-divider></v-divider>
    <v-tooltip color="rgba(0,0,0,0.9)" v-if="opened" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-list-item @click="close" v-bind="attrs" v-on="on">
          <v-list-item-icon class="mr-0">
            <v-icon>mdi-arrow-collapse-left</v-icon>
          </v-list-item-icon>
          <v-list-item-content></v-list-item-content>
        </v-list-item>
      </template>
      <span>サイドバーを非表示</span>
    </v-tooltip>
    <v-tooltip color="rgba(0,0,0,0.9)" v-else bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-list-item @click="open" v-bind="attrs" v-on="on">
          <v-list-item-icon class="mr-0">
            <v-icon>mdi-arrow-collapse-right</v-icon>
          </v-list-item-icon>
          <v-list-item-content></v-list-item-content>
        </v-list-item>
      </template>
      <span>サイドバーを常に表示</span>
    </v-tooltip>
    <v-divider></v-divider>
  </v-list>
</template>

<script>
export default {
  name: 'SidebarSwitchItem',
  props: {
    opened: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    open () {
      return this.$emit('open')
    },
    close () {
      return this.$emit('close')
    }
  }
}
</script>
